import React, { useState, useEffect, useLayoutEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Box, Typography } from "@mui/material";
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import "swiper/swiper-bundle.css";
import CircularProgress from "@mui/material/CircularProgress";

type periodSliderProps = {
  tenantId?: string;
  setActiveIndex: (tenantId: number) => void;
  setPriodId: (periodId: string) => void;
  slideData?: any;
  dataLoading?: boolean;
  activeIndex?: number;
};

const PeriodSlider = function ({
  slideData,
  setActiveIndex,
  dataLoading,
  activeIndex,
  setPriodId,
}: periodSliderProps) {
  // console.log(slideData)
  const data = [
    {
      id: "1",
    },
    {
      id: "2",
    },
  ];

  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // بررسی وضعیت موبایل
  const handleSlideChange = (swiper: any) => {
    // console.log(sw.activeIndex)

    const currentSlideIndex: any = swiper.activeIndex; // Get the active slide index
    const currentSlideData: any = slideData
      ? slideData[currentSlideIndex]
      : null; // Get data from the periods array
    //console.log(currentSlideData?.id);
    setPriodId(currentSlideData?.id);

    // setActiveIndex(swiper.activeIndex)
    // console.log(currentSlideData)
  };

  if (dataLoading) {
    return (
      <Box width={"100%"} py={4} textAlign={"center"}>
        {/* <CircularProgress sx={{ color: "blue" }} /> */}
      </Box>
    );
  }

  return (
<Box
  width={isMobile ? '300px' : '700px'} // در موبایل عرض به 100% تغییر می‌کند
  py={1}
  mx="auto"
  display="flex"
  // flexDirection="column" // در موبایل نمایش به صورت ستونی می‌شود
>      {/* <Box  width={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
    <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.7rem'}  >
    دوره قبل
     </Typography>
    </Box> */}
      <Swiper
        initialSlide={activeIndex}
        style={{ textAlign: "center", fontSize: "2rem" }}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        onRealIndexChange={() => {}}
        onSwiper={(swiper) => {}}
        onSlideChange={(swiper) => handleSlideChange(swiper)}
      >
        {slideData &&
          slideData.map((prd: any, i: number) => {
            return (
              <SwiperSlide key={i}>
               <Box width={'100%'} display={'flex'} flexDirection={"row"} alignItems={'center'} justifyContent={'start'}>
               <Box  width={'100%'}  flexDirection={"row"} display={'flex'} marginLeft={3}  justifyContent={'start'}>
    
{!isMobile && (
  <Typography
    color="blueviolet"
    textAlign="center"
    fontSize="0.65rem"
  >
    دوره قبل
  </Typography>
)}
    </Box>
    <Box width={'100%'}  display={'flex'} flexDirection={"row"}  alignItems={'center'} justifyContent={'center'}>
    <Typography
    fontWeight={700}
    color={"#00387C"}
    sx={{
      fontSize: {
        xs: "15px",  // برای صفحه‌های موبایل (کمتر از 600px)
        sm: "20px",  // برای صفحه‌های بزرگتر از 600px
      },
    }}
  >
          {prd?.name}
          </Typography>
          </Box>
          <Box width={'100%'}  display={'flex'}  justifyContent={'end'} marginRight={3} >
          {!isMobile && (

    <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.65rem'}>
    دوره بعد
     </Typography>
    )}
    </Box>
    </Box>
              </SwiperSlide>
              
            );
          })}

        {/* <div className="swiper-button-prev">
         <span>Previous</span>
       </div>
       <div className="swiper-button-next">
         <span>Next</span>
       </div> */}
      </Swiper>
      {/* <Box  width={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
    <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.7rem'}  >
    دوره بعد
     </Typography>
    </Box> */}
    </Box>
  );
};

export default PeriodSlider;

// import React, { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Box, Typography } from "@mui/material";
// import "swiper/swiper-bundle.css";
// import CircularProgress from "@mui/material/CircularProgress";
// import { Navigation, Pagination } from "swiper";

// type periodSliderProps = {
//   tenantId?: string;
//   setActiveIndex: (tenantId: number) => void;
//   setPriodId: (periodId: string) => void;
//   slideData?: any;
//   dataLoading?: boolean;
//   activeIndex?: number;
// };

// const PeriodSlider = function ({
//   slideData,
//   setActiveIndex,
//   dataLoading,
//   activeIndex,
//   setPriodId,
// }: periodSliderProps) {
//   const handleSlideChange = (swiper: any) => {
//     const currentSlideIndex = swiper.activeIndex;
//     const currentSlideData = slideData ? slideData[currentSlideIndex] : null;
//     setPriodId(currentSlideData?.id);
//   };

//   if (dataLoading) {
//     return (
//       <Box width={"100%"} py={4} textAlign={"center"}>
//         <CircularProgress sx={{ color: "blue" }} />
//       </Box>
//     );
//   }

//   return (
//     <Box width={"700px"} py={1} mx={"auto"}>
//       <Swiper
//         initialSlide={activeIndex}
//         spaceBetween={30}
//         slidesPerView={1}
//         navigation
//         pagination={{ clickable: true }}
//         onSlideChange={(swiper) => handleSlideChange(swiper)}
//         modules={[Navigation, Pagination]}
//         className="custom-swiper"
//       >
//         {slideData &&
//           slideData.map((prd: any, i: number) => {
//             return (
//               <SwiperSlide key={i} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                 <Box width={'100%'} display={'flex'} flexDirection={"row"} alignItems={'center'} justifyContent={'center'} p={2} borderRadius={2} boxShadow={3}>
//                   <Box width={'100%'} display={'flex'} flexDirection={"row"} alignItems={'center'} justifyContent={'center'} p={2}>
//                     <Typography fontWeight={700} color={"#00387C"} fontSize={"20px"}>
//                       {prd?.name}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </SwiperSlide>
//             );
//           })}
//       </Swiper>
//     </Box>
//   );
// };

// export default PeriodSlider;

// import React, { useState, useEffect, useLayoutEffect } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Box, Typography } from "@mui/material";
// import "swiper/swiper-bundle.css";
// import CircularProgress from "@mui/material/CircularProgress";

// type periodSliderProps = {
//   tenantId?: string;
//   setActiveIndex: (tenantId: number) => void;
//   setPriodId: (periodId: string) => void;
//   slideData?: any;
//   dataLoading?: boolean;
//   activeIndex?: number;
// };

// const PeriodSlider = function ({
//   slideData,
//   setActiveIndex,
//   dataLoading,
//   activeIndex,
//   setPriodId,
// }: periodSliderProps) {
//   const handleSlideChange = (swiper: any) => {
//     const currentSlideIndex: any = swiper.activeIndex; // Get the active slide index
//     const currentSlideData: any = slideData
//       ? slideData[currentSlideIndex]
//       : null; // Get data from the periods array
//     console.log(currentSlideData?.id);
//     setPriodId(currentSlideData?.id);
//   };

//   if (dataLoading) {
//     return (
//       <Box width={"100%"} py={4} textAlign={"center"}>
//         <CircularProgress sx={{ color: "blue" }} />
//       </Box>
//     );
//   }

//   return (
//         <Box width={"700px"} py={1} mx={"auto"} display={"flex"} >
//           {/* <Box  width={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
//         <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.7rem'}  >
//         دوره قبل
//          </Typography>
//         </Box> */}
//           <Swiper
//             initialSlide={activeIndex}
//             style={{ textAlign: "center", fontSize: "2rem" }}
//             spaceBetween={30}
//             slidesPerView={1}
//             navigation
//             onRealIndexChange={() => {}}
//             onSwiper={(swiper) => {}}
//             onSlideChange={(swiper) => handleSlideChange(swiper)}
//           >
//             {slideData &&
//               slideData.map((prd: any, i: number) => {
//                 return (
//                   <SwiperSlide key={i}>
//                    <Box width={'100%'} display={'flex'} flexDirection={"row"} alignItems={'center'} justifyContent={'start'}>
//                    <Box  width={'100%'}  flexDirection={"row"} display={'flex'} marginLeft={3}  justifyContent={'start'}>
//         <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.65rem'}  >
//     دوره قبل 
//          </Typography>
//         </Box>
//         <Box width={'100%'}  display={'flex'} flexDirection={"row"}  alignItems={'center'} justifyContent={'center'}>
//               <Typography
//                fontWeight={700}
//                color={"#00387C"}
//                fontSize={"20px"}
//                     >
//               {prd?.name}
//               </Typography>
//               </Box>
//               <Box width={'100%'}  display={'flex'}  justifyContent={'end'} marginRight={3} >
//         <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.65rem'}>
//         دوره بعد
//          </Typography>
//         </Box>
//         </Box>
//                   </SwiperSlide>
                  
//                 );
//               })}
    
//             {/* <div className="swiper-button-prev">
//              <span>Previous</span>
//            </div>
//            <div className="swiper-button-next">
//              <span>Next</span>
//            </div> */}
//           </Swiper>
//           {/* <Box  width={'200px'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
//         <Typography color={'blueviolet'} textAlign={'center'} fontSize={'0.7rem'}  >
//         دوره بعد
//          </Typography>
//         </Box> */}
//         </Box>
//       );
//     };

// export default PeriodSlider;
